import store from '../../store'

export const B = function () {
  const permissions = {
    index: 'report.branding.homesearch.view',
  }
  const permissionsCheck = {
    index: function () {
      return (store.getters['report/reportHS_$allPermissions'].indexOf(permissions.index) > -1)
    },
  }
  const featureEnabled = true
  return {
    permissionsCheck,
    featureEnabled,
  }
}

export default B
